/**
 * Single source of truth for the internal (post-login) navigation.
 * Used by the dashboard sidebar, the desktop navigation bar and the mobile menu.
 */
import { ActiveView } from "../../types/objects";

export interface InternalTab {
    key: ActiveView;
    label: string;
    /** Font Awesome icon class used in the sidebar. */
    icon: string;
}

export const INTERNAL_TABS: InternalTab[] = [
    { key: "portfolio", label: "Portfolio", icon: "fa-th-large" },
    { key: "messages", label: "Zprávy", icon: "fa-envelope" },
    { key: "documents", label: "Dokumenty", icon: "fa-folder" },
    { key: "contracts", label: "Smlouvy", icon: "fa-file-text" },
    { key: "contacts", label: "Kontakty", icon: "fa-users" },
    { key: "scoring", label: "Screening", icon: "fa-bar-chart" },
    { key: "reports", label: "Reporty", icon: "fa-pie-chart" },
];

export const isInternalView = (value: unknown): value is ActiveView =>
    INTERNAL_TABS.some((tab) => tab.key === value);

export const tabLabel = (key: string): string => INTERNAL_TABS.find((tab) => tab.key === key)?.label ?? "";
